import * as tslib_1 from "tslib";
import { call, put, select } from 'redux-saga/effects';
import { actions } from '../../Stream';
import { request } from '../../xhr';
import { MediaSourceType } from '../types';
import { galleryFolderSchema, collectionFolderSchema, } from '../../redux/normalizr/schemas/folder';
import { normalize } from '../../redux/normalizr';
import { putEntities } from '../../redux/entities/actions';
import { getCurrentMediaSource, getGallectionById, getCurrentFolderId, } from '../selectors';
import { getGallectionStreamId } from '../helpers';
export default function (action) {
    var _a, folderId, toFolderId, mediaSource, currentFolderId, gallection, streamId, updatedGallection, gallectionSchema, entities, params;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, folderId = _a.folderId, toFolderId = _a.toFolderId;
                return [4 /*yield*/, select(getCurrentMediaSource)];
            case 1:
                mediaSource = _b.sent();
                return [4 /*yield*/, select(getCurrentFolderId)];
            case 2:
                currentFolderId = _b.sent();
                return [4 /*yield*/, select(function (state) { return getGallectionById(state, folderId); })];
            case 3:
                gallection = _b.sent();
                streamId = getGallectionStreamId(mediaSource, currentFolderId);
                return [4 /*yield*/, put(actions.deleteItem({ streamId: streamId, item: folderId }))];
            case 4:
                _b.sent();
                updatedGallection = tslib_1.__assign({}, gallection, { parentId: toFolderId });
                gallectionSchema = mediaSource === MediaSourceType.COLLECTION
                    ? collectionFolderSchema
                    : galleryFolderSchema;
                entities = normalize(updatedGallection, gallectionSchema).entities;
                return [4 /*yield*/, put(putEntities({ entities: entities }))];
            case 5:
                _b.sent();
                params = {
                    type: mediaSource,
                    folderid: folderId,
                    to_folderid: toFolderId,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/move',
                        data: params,
                    })];
            case 6:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=moveGallection.js.map